@if ($model() != null && $currentUser() != null) {
    <div class="wrapper px-1">
        @if (!$isReadOnly()) {
            <!-- Seletor de papel -->
            @if ($isTaskPublicAgentActor() && $papeisSelector().length > 0) {
                <papel-selector [_signerId]="$inputData()?.eDocsData.signerId"
                                [_isReadOnly]="$isReadOnly()"
                                [_papeis]="$papeisSelector()"
                                [_flowObjectType]="FlowObjectType.TaskApprove"
                                (_signerIdChange)="signerIdChange($event)"
                ></papel-selector>
                <hr />
            }

            <!-- Task body: visão do executor -->
            <div class="form-container">
                <span>
                    <span style="color: red">*</span> Parecer sobre o cancelamento do Fluxo:
                </span>
                <div class="input-container text-center mt-1 mb-3 px-0">
                    <textarea id="message" placeholder="Entre com a mensagem de cancelamento" rows="4"
                                [class.minlength]="$isMissingMessage()"
                                [ngModel]="$inputData().message"
                                [readOnly]="$isReadOnly()"
                                (change)="onChangeMessage($event.target.value)"
                    ></textarea>
                </div>
                <div class="footer">
                    <button type="button" class="btn btn-outline-danger"
                            (click)="discardManualCancel()"
                            (keyDown)="discardManualCancel()"
                    >Desistir do cancelamento</button>

                    <button type="button" class="btn btn-outline-primary"
                            (click)="submit(true)"
                            (keyDown)="submit(true)"
                    >Cancelar Fluxo</button>
                </div>
            </div>
        } @else {
            <!-- Task body: visão do executor -->
            <div class="message-container">
                <div class="message-row mb-4">
                    <i class="fas fa-ban error mr-3"></i>
                    <span class="headline">
                        Fluxo cancelado manualmente por seus administradores em
                        <span class="text-highlight info-font d-inline-block">{{getDateString()}}</span>
                    </span>
                    <i class="fas fa-ban error ml-3"></i>
                </div>
                <hr />
                <p>
                    Para todos os efeitos, a presente instância de Fluxo, iniciada por
                    <span class="text-highlight info-font d-inline-block">{{$ownerInfo()}}</span>,
                    <b>não foi completada</b> e as eventuais Tarefas previamente executadas <b>não possuem validade</b>.
                </p>
                <span>
                    Inicie uma <b>nova instância</b> deste Fluxo para completar a requisição do serviço.
                </span>
            </div>

            @if ($previousDocuments().length > 0) {
                <hr />

                <div class="mb-3">
                    Parecer do administrador deste Fluxo sobre seu cancelamento:
                </div>
                <div class="documents-container">
                    @for (doc of $previousDocuments(); track doc) {
                        <div class="position-relative my-1">
                            <span class="document-highlight" (click)="openDocumentModal(doc.id)" (keyDown)="openDocumentModal(doc.id)">
                                <span class="e-docs info-font text-highlight" matTooltip="Protocolo E-Docs do documento">{{doc.registro}}</span>
                                <span class="info-font d-inline-block" matTooltip="Clique para visualizar o documento que foi capturado no E-Docs">
                                    <i class="fas fa-external-link-alt mr-1"></i><u>{{doc.filename}}</u>
                                </span>
                            </span>
                        </div>
                    }
                </div>
            }
        }
    </div>
} @else {
    <div class="wrapper loading">
        <span class="info-font text-highlight p-2">(Carregando...)</span>
    </div>
}
